import { useState } from "react";
import { Menu, X, Sun, Moon } from "lucide-react";
import { TABS } from "./Sidebar";

export default function MobileTopBar({ activeTab, onChange, darkMode, onToggleDark }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="md:hidden">
      <div className="flex items-center justify-between px-4 py-3 bg-white dark:bg-[var(--bg-surface)] border-b border-gray-100 dark:border-[var(--border-soft)]">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-brand-ink flex items-center justify-center">
            <span className="text-white font-display font-bold text-xs">U</span>
          </div>
          <span className="font-display font-semibold text-sm">UniCamel</span>
        </div>
        <div className="flex items-center gap-1">
          <button onClick={onToggleDark} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-[var(--bg-soft)] text-brand-slate">
            {darkMode ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <button onClick={() => setOpen(!open)} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-[var(--bg-soft)] text-brand-slate">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="bg-white dark:bg-[var(--bg-surface)] border-b border-gray-100 dark:border-[var(--border-soft)] px-2 py-2 space-y-0.5">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const active = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => { onChange(tab.id); setOpen(false); }}
                className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium ${active ? "bg-brand-ink text-white" : "text-brand-slate"}`}
              >
                <Icon size={16} /> {tab.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
